<template>
    <div class="w3-margin">
        <h4 class="page-title">NEVEZÉSEIM</h4>
       <div v-if="aktEntryPrice>0" class="w3-center w3-margin">
            Kérjük, hogy a nevezési díjat az alábbi számlára utald át!
            <br>Számlatulajdonos: Libertate
            <br>Számlaszám: <b>???????-????????-????????</b>
            <br>A közlemény rovatba a nevezés <span v-if="aktEntryId!=0">(<b>{{aktEntryId}}</b>)</span> sorszámát add meg!
            <br>Egyszerre több nevezés is fizethető, ez esetben a közleménybe az összes nevezés sorszámot kérjük megadni.
        </div>   
        <table class="w3-table-all w3-small"> 
            <tr class="theme-1">
                <td>Sorszám</td>
                <td>Útvonal</td>
                <td class="w3-hide-small w3-center">Nevezés dátuma</td>
                <td class="w3-hide-small w3-center">Ár</td>
                <td class="w3-hide-small w3-center">Fizetés státusza</td>
                <td class="w3-center">Útvonal felvétele</td>
            </tr>  
            <tr v-for="(item, index) in myEntries" :key="index">
                <td>{{item.id}}</td>
                <td>{{item.hikeName}}</td>
                <td class="w3-hide-small w3-center">{{item.creatDate | filterDateFormat}}</td>
                <td class="w3-hide-small w3-center">{{item.price}}  {{$appData.currency}}</td>
                <td class="w3-hide-small w3-center">{{item.status | filterPaymentStatus}}</td>
                <td class="w3-center">
                    <span v-if="item.status==2 && !item.certifyId" class="cursorpointer w3-text-blue" v-on:click="addRoute(item)"> Felveszem</span>
                    <span v-if="item.certifyId" class="w3-text-green"> Felvéve</span>
                </td>
            </tr>                                                     
        </table>
    </div>
</template>

<script>
const fb = require('../firebase.js')
export default {
    name: "MyEntries",
    data() {
        return {
            myEntries:null,
            aktEntryId:0,
            aktEntryPrice:0
        }
    },
    methods:{
        addToList2(item,entryItem){
            this.$showSpinner();
            fb.Download2(item).then(res=>{
                var storageId='ggData2-'+item.id; 
                this.$storage.set(storageId, res);  
                fb.AddToFavorite2(item,this.$store.getters.userProfile)
                .then(res=>{    
                    fb.UpdateEntry2(entryItem,res.id).then(r=>{
                        fb.GetFavoriteList(this.$store.getters.userProfile.uid).then(res=>{
                            this.$storage.set('favoriteList', res);
                        });
                        this.$hideSpinner();
                        this.$dialog.alert(this.$setDialogMsg('w3-green',item.name,'A túra hozzáadása a teljesítések listához megtörtént.')).then(r=>{
                            this.$router.push('/favoritelist');
                        });                        
                    }).catch(e=>{
                        console.log(e);
                        this.$hideSpinner();
                        this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a túra hozzáadása során.'));
                    }); 
             }).catch(e=>{
                    console.log(e);
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a túra hozzáadása során.'));
                });         
            }).catch(e=>{
                console.log(e);
                this.$hideSpinner();
                this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet',"Hiba történt az adatok letöltése során"));                 
            }); 
        },
        addRoute(item){
            this.$showSpinner();
            fb.GetFavoriteList(this.$store.getters.userProfile.uid).then(res=>{
                var favoriteList = res; 
                var isExist=false;
                for (var h in favoriteList){
                    if ((item.hikeId==favoriteList[h].hikeId) && (favoriteList[h].status<2)) {
                        isExist=true;
                        break;
                    }
                }          
                this.$hideSpinner();
                if (isExist) {
                    this.$dialog.alert(this.$setDialogMsg('w3-yellow','Figyelmeztetés',"Ez az útvonal már szerepel a listában be nem fejezett teljesítéssel. Ha újra fel szeretnéd venni, akkor először fejezd be a korábbi teljesítést."));                 
                } else {
                    fb.GetGeogo(item.hikeId).then(res=>{
                        this.addToList2(res,item);
                    }).catch(e=>{
                        console.log(e);
                        this.$hideSpinner();              
                        this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a művelet során.'));
                    }); 
                }
            }).catch(e=>{
                console.log(e);
                this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a művelet során.'));
            });
        },
        showMyEntries(){
            fb.GetUserEntries(this.$store.getters.userProfile.uid).then(r=>{
                var list=[];
                for (var i in r) {
                    list.push(r[i]);
                }
                list.sort(function(a, b) {
                    var aDate=""+a.creatDate;
                    var bDate=""+b.creatDate;
                    return bDate.localeCompare(aDate);
                });
                this.myEntries=list;
            }).catch(e=>{
                console.log(e);
            });
        }
    },
    mounted: function(){
        if (this.$route.params.aktEntryId) this.aktEntryId=this.$route.params.aktEntryId;
        if (this.$route.params.aktEntryPrice) this.aktEntryPrice=this.$route.params.aktEntryPrice;
        this.showMyEntries();
    },     
}
</script>
